import apiService from '@/services/api.service'
import store from '@/store'

export default {

    async getDirections() {
        const lang = store.state.locale;
        return new Promise((resolve, reject) => {
            apiService.getFrApi({
                url: 'wizard/getDirectionList',
                method: 'get',
                locale: lang
            }).then(response => {
                if (response.data.data){
                    resolve(response.data.data);
                } else {
                    reject('empty logins!')
                }
            }).catch((error) => {
                reject(error)
            })
        })
    },


    async getHotels(params) {
        const lang = store.state.locale;
        return new Promise((resolve, reject) => {
            apiService.getFrApi({
                url: 'wizard/getHotels',
                method: 'get',
                params: params,
                locale: lang
            }).then(response => {
                if (response.data.data){
                    resolve(response.data.data);
                } else {
                    reject('empty claims!')
                }
            }).catch((error) => {
                reject(error)
            })
        })
    },

}
